'use client';

import { Session } from 'next-auth';
import { useEffect } from 'react';

import CartService, { ProductTypes } from '@bytel/magicart';

import { getOfferWallData } from '@services/categories';

import { CategoryListType } from '@app-types/plan';
import { Product } from '@app-types/product';

import { getCart } from '@helpers/cart';
import { PremiumSubCategories, SimoSubCategories } from '@helpers/offer-wall';

import { getQuotePayload, getSimulatedPhone } from '@home-mobile/helpers';

export function useInitPhoneInCart(
    setAllCategoryList: (categoryList: CategoryListType) => void,
    setPhoneInCart: (phone: Product) => void,
    setIsLoading: (loading: boolean) => void,
    isClientBbox: boolean,
    session?: Session | null,
) {
    useEffect(() => {
        setIsLoading(true);
        getCart().then(async (cart: CartService) => {
            const phoneProductList = cart?.getAllProductsByType(ProductTypes.phone);
            const phone = phoneProductList?.[0];

            if (!phone) {
                setIsLoading(false);
                return;
            }

            const quotes = getQuotePayload(isClientBbox, phone.gencode, !!session?.user);
            const categoryList = await getOfferWallData(
                [...PremiumSubCategories, ...SimoSubCategories],
                { cart: { quotes } },
                session,
                true,
            );
            setAllCategoryList(categoryList);

            const simulatedPhone = getSimulatedPhone(categoryList?.[0]?.products?.[0]?.simulatedCart, phone.gencode);
            if (simulatedPhone) {
                setPhoneInCart({ ...phone, ...simulatedPhone });
            }
            setIsLoading(false);
        });
    }, [isClientBbox]);
}
